import Crud from '../views/NaturezaTransporte/Crud'
import Entity from '../views/NaturezaTransporte/Add'

let routes = {
    path: '/natureza_transporte',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/natureza_transporte/add',
            name: 'NewCbo',
            component: Entity
        },
        {
            path: '/natureza_transporte/edit/:id?',
            name: 'EditCbo',
            component: Entity
        },
        {
            path: '/natureza_transporte',
            name: 'list-natureza-transporte',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Natureza de Transporte',
                breadcrumb: [
                    {
                        text: 'Natureza de Transporte',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
